"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('install', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("polyline", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    points: "41.4004708 11.5509904 36.3333333 5 11.6666667 5 6.58409258 11.5509904"
  }), _react.default.createElement("path", {
    d: "M8,11 L40,11 C41.1045695,11 42,11.8954305 42,13 L42,40 C42,41.6568542 40.6568542,43 39,43 L9,43 C7.34314575,43 6,41.6568542 6,40 L6,13 C6,11.8954305 6.8954305,11 8,11 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("g", {
    transform: "translate(24.000000, 27.000000) rotate(90.000000) translate(-24.000000, -27.000000) translate(16.000000, 19.000000)",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("polyline", {
    points: "8 0 16 8 8 16"
  }), _react.default.createElement("path", {
    d: "M0,8.00833628 L16,8.00833628"
  })))));
});

exports.default = _default;